import kamala from '../../kamala'
import Switch from './Switch'

const KSwitch = {
  install: function (Vue) {
    kamala(Vue)

    Vue.component(Switch.name, Switch)
  },
}

export default KSwitch
